export function findLocalizationName(
    localizations: { language: string; name?: string | null }[] | undefined,
    code: string,
): string {
    return localizations?.find((l) => l.language.toUpperCase() === code.toUpperCase())?.name || "";
}

export function findSoundLocalization(
    localizations: { language: string; name?: string | null; soundDescription?: string | null }[] | undefined,
    code: string,
): { name: string; soundDescription: string } {
    const row = localizations?.find((l) => l.language.toUpperCase() === code.toUpperCase());
    return {
        name: row?.name || "",
        soundDescription: row?.soundDescription || "",
    };
}

export function buildNameLocalizations(values: {
    nameEN: string;
    nameFR: string;
    namePT: string;
    nameES: string;
}): { language: string; name: string }[] {
    const localizations = [
        { language: "EN", name: values.nameEN },
        { language: "FR", name: values.nameFR },
    ];
    if (values.namePT.trim()) {
        localizations.push({ language: "PT", name: values.namePT.trim() });
    }
    if (values.nameES.trim()) {
        localizations.push({ language: "ES", name: values.nameES.trim() });
    }
    return localizations;
}

export function buildSoundLocalizations(values: {
    name_en: string;
    description_en: string;
    name_fr: string;
    description_fr: string;
    name_pt: string;
    description_pt: string;
    name_es: string;
    description_es: string;
}): { language: string; name: string; soundDescription: string }[] {
    const localizations = [
        { language: "EN", name: values.name_en, soundDescription: values.description_en },
        { language: "FR", name: values.name_fr, soundDescription: values.description_fr },
    ];
    if (values.name_pt.trim() || values.description_pt.trim()) {
        localizations.push({
            language: "PT",
            name: values.name_pt.trim() || values.name_en,
            soundDescription: values.description_pt,
        });
    }
    if (values.name_es.trim() || values.description_es.trim()) {
        localizations.push({
            language: "ES",
            name: values.name_es.trim() || values.name_en,
            soundDescription: values.description_es,
        });
    }
    return localizations;
}
